import { render, staticRenderFns } from "./AdminEditPictureModal.vue?vue&type=template&id=165b49eb&scoped=true&"
import script from "./AdminEditPictureModal.vue?vue&type=script&lang=js&"
export * from "./AdminEditPictureModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditPictureModal.vue?vue&type=style&index=0&id=165b49eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b49eb",
  null
  
)

export default component.exports